import DevAuthAPI from "../api/DevAuth";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { hideLoader, showLoader } from "../util/loader/CustomLoader";
import { CustomToast } from "../util/custom-toast/CustomToast";
import { useHistory } from "react-router";

// const roles = [
//   {
//   "id": "rol_DBIbGhD99dLAvpu6",
//   "name": "admin",
//   "description": "Have all access"
//   },
//   {
//   "id": "rol_PEYtQ4aZ8FCZjLjA",
//   "name": "developer",
//   "description": "have restricted access"
//   },
//   {
//   "id": "rol_a778hb1tPSzRc2VU",
//   "name": "owner",
//   "description": "Organization owner of dev console"
//   },
//   {
//   "id": "rol_o4mrXJP16A7MhoFv",
//   "name": "qa",
//   "description": "have no user access"
//   }
//   ]

export const useGetDev = (devid) => {
  const history = useHistory();
  const { data, isLoading, isError } = useQuery(
    "getDev",
    async () => {
      let api = new DevAuthAPI();
      const res = await api.getDeveloper(devid);
      return res.data.data;
    },
    {
      onError: (error) => {
        history.replace(history.location.pathname, {
          errorStatusCode: error.response ? error.response.status : 500,
        });
      },
    }
  );
  return { data, isLoading, isError };
};

export const useGetAllUsers = (setAllUsersFiltered) => {
  const history = useHistory();
  const { data, isLoading, isError } = useQuery(
    "getAllUsers",
    async () => {
      let api = new DevAuthAPI();
      const res = await api.getAllUser();
      setAllUsersFiltered(res.data.data);
      return res.data.data;
    },
    {
      onError: (error) => {
        history.replace(history.location.pathname, {
          errorStatusCode: error.response ? error.response.status : 500,
        });
      },
    }
  );
  return { data, isLoading, isError };
};

export const useUpdateDev = (devid) => {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, isError, isLoading, error } = useMutation(
    async (data) => {
      const api = new DevAuthAPI();
      await api.updateDev(devid, data);
    },
    {
      onMutate: () => {
        showLoader();
      },
      onSuccess: () => {
        hideLoader();
        CustomToast("Dev data updated!");
        queryClient.invalidateQueries("getDev", { exact: true });
      },
      onError: (error) => {
        console.log(error.response.data);
        hideLoader();
        CustomToast(error.response.data.message);
      },
    }
  );
  return { mutate, isSuccess, isError, isLoading, error };
};

export const useChangePass = (devid, setShowChangePass) => {
  const { mutate, isSuccess, isError, isLoading, error } = useMutation(
    async (data) => {
      const api = new DevAuthAPI();
      await api.changePass(devid, data);
    },
    {
      onMutate: () => {
        showLoader();
      },
      onSuccess: () => {
        hideLoader();
        setShowChangePass(false);
        CustomToast("Password Changed");
      },
      onError: (error) => {
        hideLoader();
        CustomToast(error.response.data.message);
      },
    }
  );
  return { mutate, isSuccess, isError, isLoading, error };
};

export const useDeleteUser = (id) => {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, isError, isLoading, error } = useMutation(
    async () => {
      const api = new DevAuthAPI();
      await api.deleteUser(id);
    },
    {
      onMutate: () => {
        console.log("loading");
        showLoader();
      },
      onSuccess: () => {
        hideLoader();
        CustomToast("User deleted");
        queryClient.invalidateQueries("getAllUsers", { exact: true });
      },
      onError: (error) => {
        console.log(error);
        hideLoader();
        CustomToast(error.response.data.message);
      },
    }
  );
  return { mutate, isError, isLoading, isSuccess, error };
};

export const useInviteUser = (setShowInviteMember) => {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, isError, isLoading, error } = useMutation(
    async (data) => {
      const api = new DevAuthAPI();
      await api.inviteUser(data);
    },
    {
      onMutate: () => {
        showLoader();
      },
      onSuccess: () => {
        hideLoader();
        CustomToast("User Invited");
        setShowInviteMember(false);
        queryClient.invalidateQueries("getAllUsers", { exact: true });
      },
      onError: (error) => {
        console.log(error.response.data);
        hideLoader();
        CustomToast(error.response.data.message);
      },
    }
  );
  return { mutate, isSuccess, isError, isLoading, error };
};

export const useResendInviteUser = (setShowResendInviteLinkModal) => {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, isError, isLoading, error } = useMutation(
    async (data) => {
      const api = new DevAuthAPI();
      await api.resendInviteUser(data);
    },
    {
      onMutate: () => {
        showLoader();
      },
      onSuccess: () => {
        hideLoader();
        CustomToast("User Invited");
        setShowResendInviteLinkModal(false)
        queryClient.invalidateQueries("getAllUsers", { exact: true });
      },
      onError: (error) => {
        console.log(error.response.data);
        hideLoader();
        CustomToast(error.response.data.message);
      },
    }
  );
  return { mutate, isSuccess, isError, isLoading, error };
};

export const useAssignRole = (devid, setShowAssignModal) => {
 const roles= useGetRoles().data;
 
  const queryClient = useQueryClient();
  const { mutate, isSuccess, isError, isLoading, error } = useMutation(
  
    async (role) => {
      let data = {roles:roles.filter((item)=>{
        if(item.name===role){
          return item
        }
      }).map(function(obj) { return obj.id; })}

      const api = new DevAuthAPI();
      await api.assignRole(devid, data);
    },
    {
      onMutate: () => {
        showLoader();
      },
      onSuccess: () => {
        hideLoader();
        CustomToast("Role Assigned");
        setShowAssignModal(false);
        queryClient.invalidateQueries("getAllUsers", { exact: true });
      },
      onError: (error) => {
        console.log(error.response.data);
        hideLoader();
        CustomToast(error.response.data.message);
      },
    }
  );
  return { mutate, isSuccess, isError, isLoading, error };
};


export const useGetRoles = (categoryType) => {
  const { data, isLoading, isError } = useQuery(["getCategory", categoryType], async () => {
    // let api = new DevAppAPI();
    
    const api = new DevAuthAPI();
    let res=  await api.getAvailableRoles();
    // debugger;
    // console.log(res.data.data)
    return res.data.data;
    // const builds = res.data.data.map((build) => ({
    //   ...build,
    //   created_at: formatDate(build.created_at),
    //   updated_at: formatDate(build.updated_at),
    // }));
    
  });
  return { data, isLoading, isError };
};

